export default "__VITE_ASSET__DAq37TqD__"